import {environment} from '@environments/environment';

const events = {
    translate: 'MENU.ITEM.EVENTS',
    text: '',
    link: '/events',
    icon: 'icon-calendar'
};

const campaigns = {
    translate: 'MENU.ITEM.CAMPAIGNS',
    text: '',
    link: '/campaigns',
    icon: 'icon-envelope-letter'
};

const frontdesk = {
    translate: 'MENU.ITEM.FRONTDESK',
    text: '',
    link: '/frontdesk',
    icon: 'icon-login'
};

const templates = {
    translate: 'MENU.ITEM.TEMPLATES',
    text: '',
    link: '/templates',
    icon: 'icon-layers'
};

const publicpages = {
    translate: 'MENU.ITEM.PUBLICPAGES',
    text: '',
    link: '/publicpages',
    icon: 'icon-globe'
};

const addresssBook = {
    translate: 'MENU.ITEM.ADDRESSBOOK',
    text: '',
    link: '/addressbook',
    icon: 'icon-notebook'
};

const payments = {
    translate: 'MENU.ITEM.PAYMENTS',
    text: '',
    elink: environment.engage.baseUrl + `/login-backdoor?tenantid={tenantid}&page=${encodeURIComponent('payments')}`,
    icon: 'icon-credit-card'
};

const report = {
    translate: 'MENU.ITEM.REPORTS',
    text: '',
    link: '/reports',
    icon: 'icon-chart'
};

const usersTeams = {
    translate: 'MENU.ITEM.USERSTEAMS',
    text: '',
    link: '/usersteams',
    icon: 'icon-people'
};

const settings = {
    translate: 'MENU.ITEM.SETTINGS',
    text: '',
    link: '/settings',
    icon: 'icon-settings'
};

const support = {
    translate: 'MENU.ITEM.SUPPORT',
    text: '',
    link: '/support',
    icon: 'icon-support'
};

const surveys = {
    translate: 'MENU.ITEM.SURVEYS',
    text: '',
    link: '/surveys',
    icon: 'fa fa-calendar-check-o'
};

const integration = {
    translate: 'MENU.ITEM.INTEGRATION',
    text: '',
    link: '/integrations',
    icon: 'fa fa-sitemap'
};

const library = {
    translate: 'MENU.ITEM.LIBRARY',
    text: '',
    link: '/library',
    icon: 'fa fa-book'
};

const filecenter = {
    translate: 'MENU.ITEM.FILECENTER',
    text: '',
    link: '/filecenter',
    icon: 'fa fa-files-o'
};

const tenantSettings = {
    translate: 'MENU.ITEM.SETTINGS',
    text: '',
    link: '',
    icon: 'icon-settings',
    submenu: [
        support,
        templates,
        library,
        usersTeams,
        integration,
        settings,
    ]
};

const reports = {
    translate: 'MENU.ITEM.REPORTS',
    text: '',
    link: '',
    icon: 'icon-chart',
    submenu: [
        report,
        filecenter,
    ]
};

export { payments };

export const menu = [
    events,
    frontdesk,
    addresssBook,
    publicpages,
    campaigns,
    payments,
    reports,
    tenantSettings,
];
